export const SET_STAFF = "DASHBOARD/SET_STAFF" 
export const SET_PARTAKERS = "DASHBOARD/SET_PARTAKERS" 
export const TOGGLE_STATUS_CHECKIN = "DASHBOARD/TOGGLE_STATUS_CHECKIN" 
export const SET_STAFFS = "DASHBOARD/SET_STAFFS" 
export const SET_PAYOUTS = "DASHBOARD/SET_PAYOUTS" 
export const SET_COUPONS = "DASHBOARD/SET_COUPONS" 
export const RESET_STAFFS = "DASHBOARD/RESET_STAFFS" 
export const RESET_COUPONS = "DASHBOARD/RESET_COUPONS" 
export const ADD_PAYOUT_FROM_PAYOUTS = "DASHBOARD/ADD_PAYOUT_FROM_PAYOUTS" 
export const TOGGLE_ISVIEWMOBILE = "DASHBOARD/TOGGLE_ISVIEWMOBILE" 
export const CLOSE_ISVIEWMOBILE = "DASHBOARD/CLOSE_ISVIEWMOBILE" 
export const REMOVE_STAFF_FROM_STAFFS = "DASHBOARD/REMOVE_STAFF_FROM_STAFFS" 
export const ADD_STAFF_FROM_STAFFS = "DASHBOARD/ADD_STAFF_FROM_STAFFS" 
export const ADD_COUPON_FROM_COUPONS = "DASHBOARD/ADD_COUPON_FROM_COUPONS" 
export const UPDATE_STAFF_FROM_STAFFS = "DASHBOARD/UPDATE_STAFF_FROM_STAFFS" 